import { ReportHandler } from "web-vitals";
import { analytics } from "./services/analytics";

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }

  // Also send web vitals to Google Analytics
  if (typeof window !== "undefined") {
    import("web-vitals").then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS((metric) => {
        analytics.trackEvent(
          "web_vital_cls",
          "performance",
          `CLS: ${metric.value.toFixed(3)}`,
          Math.round(metric.value * 1000)
        );
      });

      getFID((metric) => {
        analytics.trackEvent(
          "web_vital_fid",
          "performance",
          `FID: ${metric.value.toFixed(0)}ms`,
          Math.round(metric.value)
        );
      });

      getFCP((metric) => {
        analytics.trackEvent(
          "web_vital_fcp",
          "performance",
          `FCP: ${metric.value.toFixed(0)}ms`,
          Math.round(metric.value)
        );
      });

      getLCP((metric) => {
        analytics.trackEvent(
          "web_vital_lcp",
          "performance",
          `LCP: ${metric.value.toFixed(0)}ms`,
          Math.round(metric.value)
        );
      });

      getTTFB((metric) => {
        analytics.trackEvent(
          "web_vital_ttfb",
          "performance",
          `TTFB: ${metric.value.toFixed(0)}ms`,
          Math.round(metric.value)
        );
      });
    });
  }
};

export default reportWebVitals;
